import React from "react";
import { Redirect, useLocation, useParams } from "react-router-dom";

import {
  FormContainer,
  FormContainerItem,
  SuccessBanner,
} from "@graffer-inc/console-design-kit";

import { useAuthContextV2 } from "../../../../../auth-state";
import { useServiceAccountDetailPage } from "../../../../../hooks/service-account/service-account-detail";
import { parseQueryOfLocation } from "../../../../../utils/url-utils";
import { ServiceAccountDetailContent } from "../../../../organisms/service-account/service-account-detail-content/service-account-detail-content";
import { SettingsTemplate } from "../../../../template/settings/default-template";
import { SettingR } from "../../route";

export const ServiceAccountDetailPage: React.FC = () => {
  const { auth } = useAuthContextV2();
  const { id: serviceAccountId } = useParams<{ id: string }>();

  if (!auth.hasPermissions("service_account.service_account.read")) {
    return <Redirect to={SettingR.MyAccount.link({})} />;
  }

  return (
    <SettingsTemplate
      breadcrumbs={[
        {
          to: SettingR.ServiceAccounts.link({}),
          title: "サービスアカウント一覧",
        },
        { to: "#", title: "詳細" },
      ]}
    >
      {auth.data?.orgId && (
        <Content
          tenantId={auth.data.orgId}
          serviceAccountId={serviceAccountId}
        />
      )}
    </SettingsTemplate>
  );
};

const Content: React.FC<{ tenantId: string; serviceAccountId: string }> = ({
  tenantId,
  serviceAccountId,
}) => {
  const {
    pageContent,
    createServiceAccountKey,
    updateServiceAccount,
    disableServiceAccount,
    disableServiceAccountKey,
  } = useServiceAccountDetailPage({
    tenantId,
    serviceAccountId,
  });

  const { isNewlyCreated } = parseQueryOfLocation(useLocation());
  const [showNewlyCreatedBanner, setShowNewlyCreatedBanner] = React.useState(
    isNewlyCreated === "true",
  );

  return (
    <>
      {showNewlyCreatedBanner && (
        <div className="mb-5">
          <NewlyCreatedBanner
            onClose={() => {
              setShowNewlyCreatedBanner(false);
            }}
          />
        </div>
      )}
      {!!pageContent && (
        <ServiceAccountDetailContent
          serviceAccount={pageContent.serviceAccount}
          serviceAccountKeys={pageContent.serviceAccountKeys}
          groups={pageContent.groups}
          onClickServiceAccountKeyCreate={createServiceAccountKey}
          onClickUpdateServiceAccount={updateServiceAccount}
          onClickDisableServiceAccount={disableServiceAccount}
          onClickDisableServiceAccountKey={disableServiceAccountKey}
        />
      )}
    </>
  );
};

const NewlyCreatedBanner: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  return (
    <FormContainer>
      <FormContainerItem>
        <SuccessBanner
          message="サービスアカウントを作成しました"
          onClose={onClose}
        />
      </FormContainerItem>
    </FormContainer>
  );
};
